module.exports = __webpack_public_path__ + "img/card_informe_cumplimiento_servicios_relacionados.263889f0.svg";